import state from "./state"

const mutations = {
  SET_FORM_PAGINATION (state, data) {
    let paginationInfo = data

    const {number, numberOfElements, totalElements, totalPages} = paginationInfo;

    paginationInfo.totalPages = totalPages;
    paginationInfo.current_page = number;
    paginationInfo.number_of_elements = numberOfElements;
    paginationInfo.total_elements = totalElements;
    paginationInfo.total_pages = totalPages;
    
    state.pagination = {
      ...state.pagination,
      ...paginationInfo
    }
  },
  SET_FORM_LIST (state, data) {
    state.items = data
  },
  SET_FACEBOOK_TO_EDIT (state, data) {
    const facebookInfo = JSON.parse(JSON.stringify(data))
    state.facebookToEdit = {
      ...state.facebookToEdit,
      ...facebookInfo
    }
  },
  UNSET_COMMUNICATION_TO_EDIT (state, data) {
    state.facebookToEdit = {
      copy: {
        copy_id: null,
        copy_name: '',
        product: {
          product_id: null,
          product_name: '',
          product_is_active: null,
          product_updated_at: ''
        },
        copy_is_active: null,
        copy_updated_at: ''
      },
      communication_text: '',
      communication_text_normalized: '',
      communication_id_shot: '',
      communication_comment_shot: '',
      communication_type: '',
      communication_is_active: true,
      communication_is_formula_lancamento: true,
      communication_approval: true,
      communication_relationship: true,
      facebook_updated_at: ''
    }
  },
  SET_PAGE (state, data) {
    state.page = data
  },
  SET_STATUS_FILTER (state, data) {
    state.is_active = data
  },
  SET_PRODUCT_FILTER (state, data) {
    state.product_id = data
  },
  SET_SEARCH_TEXT_FILTER (state, data) {
    state.search_text = data
  },

  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_NEW_FORM (state, data) {
    state.newCampaign = data
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/facebook/mutations.js